import {createStore} from "solid-js/store";

export const [translations, setTranslations] = createStore<{ [_: string]: string }>({});